export const intentCategories = {
    FHA_FB_EXTN: "FHA_FB_EXTN",
    FHA_FB_NO_EXTN: "FHA_FB_NO_EXTN",
    FHA: "FHA",
    FHA_FB_NO_COVID: "FHA_FB_NO_COVID",
    FHA_NO_FB: "FHA_NO_FB",
    FHA_NO_FB_NO_COVID: "FHA_NO_FB_NO_COVID",
    FHA_FB_EXTN_NO_COVID: "FHA_FB_EXTN_NO_COVID",
    FHA_FB_NO_EXTN_NO_COVID: "FHA_FB_NO_EXTN_NO_COVID"
}